import { v4 as uuidv4 } from "uuid";
import moment from "moment";

export const generateFormattedKOTs = (orderData, tillData, selectedProductIds = []) => {
  // Load stored token data for KOT tokens
  const storedTokenData = JSON.parse(localStorage.getItem("tokenData") || "{}");
  const currentDate = moment().format("YYYY-MM-DD");

  // Construct vendors from valid lines, similar to receiptData logic
  const vendors = [];
  let tokenCounter = storedTokenData[currentDate] || 0;
  const productionCenters = {};

  // Filter items to only those matching selectedProductIds (mProductId-matched)
  const filteredItems =
    orderData?.items?.filter((line) => {
      // Assuming line.mProductId or line.productId matches the selected mPoductId
      // Adjust key if it's line.productId instead of line.mProductId
      const itemProductId = line.mProductId || line.lineId;
      return !selectedProductIds.length || selectedProductIds.includes(itemProductId);
    }) || [];

  filteredItems.forEach((line) => {
    const productionCenter = line.productionCenter || "Unknown P C"; // Fallback if productionCenter is empty
    const productionCenterId = line.productionCenterId || "";
    const printerId = line?.printerId ? line.printerId : "";

    // Only process items with a valid productionCenterId
    if (productionCenterId && !orderData?.externalId) {
      if (!productionCenters[productionCenter]) {
        tokenCounter++; // Increment tokenCounter for each new productionCenter
        const newToken = `T-${tokenCounter}`;
        productionCenters[productionCenter] = {
          productionCenter: productionCenter,
          productionCenterId: productionCenterId,
          token: newToken,
          items: [],
          subTotal: 0,
          printerId: printerId,
        };
        vendors.push(productionCenters[productionCenter]);
      }
      productionCenters[productionCenter].items.push({
        name: line.name || "",
        weight: line.weight || 1, // Quantity
        grossunit: parseFloat(line.grossunit || line.salePrice || 0).toFixed(2), // Price per unit
        linegross: parseFloat(line.linegross || line.nettotal || 0).toFixed(2), // Total per line
        addons: line.selectedAddons || [],
        preparationTime: line?.preparationTime || null,
        notes: line?.notes || null,
        kotTokenId: line?.kotTokenId,
      });
      productionCenters[productionCenter].subTotal += parseFloat(line.lineGross || 0);
    }
  });

  // Store updated token data only if at least one item was processed (i.e., vendors exist)
  if (vendors.length > 0) {
    storedTokenData.date = currentDate;
    storedTokenData[currentDate] = tokenCounter; // Update for the current date
    localStorage.setItem("tokenData", JSON.stringify(storedTokenData));
  }

  // Add vendors to orderData for potential further use
  orderData.vendors = vendors;

  // Construct KOTs array similar to upsertPOSKOT logic
  let formattedKots = [];
  for (const vendor of vendors) {
    // Updated: Generate tokenId and convert to uppercase after removing hyphens
    // const tokenId = uuidv4().replace(/-/g, "").toUpperCase();
    const tokenId = vendor?.items?.[0]?.kotTokenId || vendor?.items?.[0]?.tokenId || "";
    const timestamp = new Date().toISOString();
    const userData = JSON.parse(localStorage.getItem("userData"));
    const kotJson = JSON.stringify({
      tokenId,
      orderId: orderData?.sOrderID || "",
      orderNo: orderData?.documentno || "",
      tokenNo: vendor?.token || "",
      productionCenter: vendor?.productionCenter || "",
      productionCenterId: vendor?.productionCenterId || "",
      updatedAt: timestamp,
      updatedBy: userData?.user || "",
      items: vendor?.items?.map((item) => ({
        qty: Math.floor(item.weight),
        productName: item.name,
        subProducts: item?.addons || [],
        preparationTime: item?.preparationTime || 1,
        notes: item?.notes || null,
        updatedAt: timestamp,
        updatedBy: userData?.user || "",
      })),
      orderDate: orderData.orderDate,
      orderTime: orderData.orderTime,
      customer: orderData.customer,
      total: vendor.items.reduce((sum, item) => sum + (item.total || 0), 0), // Calculate total for vendor items
      saleType: orderData?.saleType || {},
      tableNo: orderData?.tableNo || null,
      printerId: vendor?.printerId || null,
    });

    const kotObject = `{
    cwrFbKotId: "${tokenId}"
    bunitId: "${tillData.tillAccess.csBunit.csBunitId}"
    cwrFbProductionCenterId: ${vendor.productionCenter ? `"${vendor.productionCenter}"` : null}
    kotJson: ${JSON.stringify(kotJson)}
    kotNo: ${vendor.token ? `"${vendor.token}"` : null}
    orderNo: ${orderData?.documentno ? `"${orderData?.documentno}"` : ""}
    tillId: "${tillData.tillAccess.cwrTill.cwrTillID}"
    salesRepId: ${orderData.salesRepId ? `"${orderData.salesRepId}"` : null}
  }`;

    formattedKots.push(kotObject);
  }

  return formattedKots;
};
